import { render, staticRenderFns } from "./advertisingChannel.vue?vue&type=template&id=1c135f88&"
import script from "./advertisingChannel.vue?vue&type=script&lang=js&"
export * from "./advertisingChannel.vue?vue&type=script&lang=js&"
import style0 from "./advertisingChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c135f88')) {
      api.createRecord('1c135f88', component.options)
    } else {
      api.reload('1c135f88', component.options)
    }
    module.hot.accept("./advertisingChannel.vue?vue&type=template&id=1c135f88&", function () {
      api.rerender('1c135f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/advertisingChannel.vue"
export default component.exports